import { requestGet, requestGetForm, requestPost, requestPostForm } from "@/config/http-json";

const produce = {
  async brandList() {
    const resp = await requestGetForm("/omni/produce/selectBrandList");
    return resp;
  },

  async scanBrandQrcode(data) {
    const resp = await requestGetForm("/omni/produce/selectQrCodeStatus", data);
    return resp;
  },
  async uploadTagInfo(data) {
    const resp = await requestPostForm("/omni/produce/uploadNfcData", data);
    return resp;
  },
  async uploadWriteTagInfo(data) {
    const resp = await requestPostForm("/omni/produce/uploadNfcData", data);
    return resp;
  },
  async scanBrandRecordList(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectScanRecord", data, { showProgress });
    return resp;
  },

  async selectBrandAndProduct(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectBrandAndProduct", data, { showProgress });
    return resp.data;
  },
  async selectBrandScanTime(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectBrandScanTime", data, { showProgress });
    return resp.data;
  },
  async myBrands(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectMyBrand", data, { showProgress });
    return resp.data;
  },
  async modifyBrand(data, showProgress = false) {
    const resp = await requestPost("/omni/produce/updateBrandById", data, { showProgress });
    return resp;
  },
  async addBrand(data, showProgress = false) {
    const resp = await requestPost("/omni/produce/saveBrand", data, { showProgress });
    return resp;
  },
  async myProducts(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectAllProduct", data, { showProgress });
    return resp.data;
  },
  async flavors(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectFlavorByBrandAndDeviceId", data, { showProgress });
    return resp.data;
  },
  async ingredients(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectIngredients", data, { showProgress });
    return resp.data;
  },
  async flavorLabels(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectAllFlavorLabel", data, { showProgress });
    return resp.data;
  },
  async addFlavor(data, showProgress = false) {
    const resp = await requestPost("/omni/produce/saveFlavor", data, { showProgress });
    return resp;
  },
  async flavorInfo(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectFlavorById", data, { showProgress });
    return resp.data;
  },
  async flavorHistory(data, showProgress = false) {
    const resp = await requestGetForm("/omni/produce/selectScanRecord", data, { showProgress });
    return resp.data;
  },
  async deleteFlavor(data, showProgress = false) {
    const resp = await requestPost("/omni/produce/deleteFlavorById", data, { showProgress });
    return resp;
  },
  async deleteBrand(data, showProgress = false) {
    const resp = await requestPost("/omni/produce/deleteBrandById", data, { showProgress });
    return resp;
  },

};

export default produce;